import { canUseDOM, withNamespace } from '../helpers';

const getValue = (key: string): unknown => {
  if (!canUseDOM) {
    return null;
  }
  try {
    const value = localStorage.getItem(withNamespace(key));
    if (typeof value !== 'string') {
      return null;
    }
    return JSON.parse(value);
  } catch (error) {
    //
  }
  return null;
};

const setValue = (key: string, value: unknown): unknown => {
  if (!canUseDOM) {
    return null;
  }
  localStorage.setItem(withNamespace(key), JSON.stringify(value));
  return null;
};

export { getValue, setValue };
